import { createAction } from '../../../store.model';
import { Sort } from '../../grid';
import { ActionType } from '../landing.action';
import { GridType } from '../model/grid-type.model';

export interface SortRows {
    grid: GridType;
    options: Sort;
}

export const sortRows = createAction<ActionType, SortRows>(
    ActionType.EVAL_LANDING__SORT_ROWS,
);
